import React, { useEffect } from 'react';
import './AdminLogin.scss';
import { useDispatch } from "react-redux";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { setAuthenticationSuccess } from '../../store/reducers/authSlice';

const AdminLogin = () => {
    const { id, sessionToken: paramSessionToken } = useParams();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const idToken = id || searchParams.get('idToken') || searchParams.get('id');
        const sessionToken =
            searchParams.get('sessionToken') ||
            searchParams.get('session_token') ||
            paramSessionToken;
        const refreshToken =
            searchParams.get('refreshToken') ||
            searchParams.get('refresh_token');

        if (sessionToken) {
            localStorage.setItem('ee-session-token', sessionToken);
            axios.defaults.headers.common['X-SESSION-TOKEN'] = sessionToken;
        } else {
            localStorage.removeItem('ee-session-token');
            delete axios.defaults.headers.common['X-SESSION-TOKEN'];
        }

        dispatch(
            setAuthenticationSuccess({
                data: {
                    idToken: idToken,
                    sessionToken: sessionToken,
                    refreshToken: refreshToken,
                },
            })
        );
        navigate('/');
    }, [id, paramSessionToken, searchParams, dispatch, navigate]);

    return (
        <div className='adminLOGIN-con'>Loading ....</div>
    );
};

export default AdminLogin;